import { render, staticRenderFns } from "./SiteMenu.vue?vue&type=template&id=4c2fc42c&scoped=true"
import script from "./SiteMenu.vue?vue&type=script&lang=js"
export * from "./SiteMenu.vue?vue&type=script&lang=js"
import style0 from "./SiteMenu.vue?vue&type=style&index=0&id=4c2fc42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2fc42c",
  null
  
)

export default component.exports